if (!customElements.get('main-nav')) {
  class MainNav extends HTMLElement {
    constructor() {
      super()
      this.searchOpenButton = this.querySelector('#nav__tab--search')
      this.mobileSearchOpenButton = this.querySelector('#mobile-open-search')
      this.searchBar = document.querySelector('search-bar')
      this.lastScrollY = 0
      this.isSticky = false
    }

    connectedCallback() {
      window.addEventListener('scroll', this.handleScroll.bind(this))
      if (this.dataset.isSticky) {
        this.isSticky = true
        this.closest('.main-nav__wrapper').classList.add('is-sticky')
      }
      this.searchOpenButton.addEventListener('click', this.toggleSearch.bind(this))
      this.mobileSearchOpenButton.addEventListener('click', this.toggleSearch.bind(this))
      this.querySelectorAll('[data-open-mobile-menu]').forEach((menuToggle) => {
        menuToggle.addEventListener('click', this.openMobileMenu.bind(this))
      })
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll.bind(this))
    }

    handleScroll() {
      const currentScrollY = window.scrollY
      const isMobile = window.innerWidth < 768
      const navWrapper = this.closest('.main-nav__wrapper')
      const announcementBar = document.querySelector('.new-announcement-bar__wrapper')

      // Check for user's motion preferences
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      // Handle scrolled class for logo scaling
      if (currentScrollY === 0) {
        this.classList.remove('scrolled')
      } else {
        this.classList.add('scrolled')
      }

      // Handle mobile sticky nav hide/show behavior
      // Respect user's motion preferences - disable auto-hide if they prefer reduced motion
      if (this.isSticky && isMobile && !prefersReducedMotion) {
        const scrollDirection = currentScrollY > this.lastScrollY ? 'down' : 'up'

        if (this.searchBar.classList.contains('active')) {
          announcementBar.classList.remove('nav-hidden')
          navWrapper.classList.remove('nav-hidden')
          return
        }

        // Check if announcement bar has dep selector on mobile
        const announcementBarElement = document.querySelector('.new-announcement-bar')
        const hasDepSelector =
          announcementBarElement && announcementBarElement.classList.contains('has-dep-selector')
        const shouldKeepVisible = hasDepSelector && window.innerWidth <= 767

        if (scrollDirection === 'down' && currentScrollY > 50) {
          // Hide both announcement bar and main nav
          // Don't hide if announcement bar has dep selector on mobile
          if (!shouldKeepVisible) {
            if (announcementBar && announcementBar.classList.contains('is-sticky')) {
              announcementBar.classList.add('nav-hidden')
            }
            navWrapper.classList.add('nav-hidden')
          }
        } else if (scrollDirection === 'up' || currentScrollY <= 50) {
          // Show both announcement bar and main nav
          if (announcementBar && announcementBar.classList.contains('is-sticky')) {
            announcementBar.classList.remove('nav-hidden')
          }
          navWrapper.classList.remove('nav-hidden')
        }
      }

      this.lastScrollY = currentScrollY
    }

    toggleSearch() {
      if (this.searchBar.getAttribute('aria-hidden') === 'true') {
        this.searchBar.openSearch()
      } else {
        this.searchBar.closeSearch()
      }
    }

    openMobileMenu(event) {
      event.preventDefault()
      const hamburger = document.querySelector('#primary-nav-toggle')
      if (!hamburger) return
      hamburger.click()

      const mobileNavCategories = document.querySelector('mobile-nav-categories')
      const target = event.target.dataset.openMobileMenu
        ? event.target
        : event.target.closest('[data-open-mobile-menu]')
      const menuHandle = target.dataset.openMobileMenu
      const mobileNavTypeSelector = document.querySelector(
        `mobile-nav-type-selector [name="type-selector-mobile-nav"][value="${menuHandle}"]`,
      )
      if (mobileNavCategories !== null && mobileNavTypeSelector !== null && menuHandle) {
        mobileNavCategories.setAttribute('data-menu-handle', menuHandle)
        mobileNavCategories.switchMenu(menuHandle)
        mobileNavTypeSelector.checked = true
      }
    }
  }
  customElements.define('main-nav', MainNav)
}
